import { render, staticRenderFns } from "./UiProgressBar.vue?vue&type=template&id=558a75b2&scoped=true"
import script from "./UiProgressBar.vue?vue&type=script&lang=js"
export * from "./UiProgressBar.vue?vue&type=script&lang=js"
import style0 from "./UiProgressBar.vue?vue&type=style&index=0&id=558a75b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558a75b2",
  null
  
)

export default component.exports